export default __webpack_public_path__ + "static/media/twitter.9e81c961.svg";